import { withInstall } from '@lit-element/utils'

import CodeEditor from './src/codeEditor.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCodeEditor: SFCWithInstall<typeof CodeEditor> =
  withInstall(CodeEditor)
export default LtCodeEditor

export * from './src/codeEditor'
